export const CHECK_SUBMIT_EVENT = 'CHECK_SUBMIT_EVENT';

export function checkSubmitEventAction() {
    return {
      type: CHECK_SUBMIT_EVENT
    }
  }